module.exports = __webpack_public_path__ + "static/media/logoNew.6a57e867.png";